export const Urls = {
  HOME: '/',
  LOGIN: '/login',
  SIGNUP: '/signup',
  FEED: '/feed',

  BATTLES: '/battles',
  BATTLES_ADD: '/battles/add',
  BATTLES_EDIT: '/battles/edit',              // + /:id
  BATTLES_JUDGE_PANEL: '/battles/judge-panel', // + /:id
  BATTLES_VERDICTS: '/battles/verdicts',       // + /:id
  BATTLES_MY_VERDICT: '/battles/verdicts',     // + /:uuid/my-verdict
  BATTLES_HIGHLIGHTS: '/battles/highlights',   // + /:id
  BATTLES_COMMENTS: '/battles/comments',       // + /:uuid (video segment comments)

  BATTLES_SETS: '/sets',

  COMPETITORS: '/competitors',
  COMPETITORS_ADD: '/competitors/add',
  COMPETITORS_EDIT: '/competitors/edit',       // + /:id
  COMPETITORS_BATTLES: '/competitors/battles', // + /:id

  ADMINISTRATION: '/admin',
  ADMINISTRATION_USERS: '/admin/users',
  ADMINISTRATION_ADD_USER: '/admin/users/add',
  ADMINISTRATION_LOGS: '/admin/logs',
  ADMINISTRATION_CONFIGURATION: '/admin/configuration',
  LEADERBOARD: '/leaderboard',
  JUDGES: '/judges',
  JUDGE_PROFILE: '/judge', // + /:uuid
  MY_ACCOUNT: '/my-account',
  USER_PROFILE: '/user-profile',
  USER_PROFILE_PROFILE: '/user-profile/profile',
  USER_PROFILE_CHANGE_PASSWORD: '/user-profile/change-password',
  USER_PROFILE_THEME: '/user-profile/theme',
  USER_PROFILE_INTERFACE: '/user-profile/interface',
  USER_PROFILE_CHANGELOG: '/user-profile/changelog',
  USER_PROFILE_NOTIFICATIONS: '/user-profile/notifications',
  USER_PROFILE_DELETE_ACCOUNT: '/user-profile/delete-account',
  PAGE_NOT_FOUND: '/page-not-found',
  SHARED: 'shared',
  INFORMATION: '/information',
};

export const Endpoints = {
  CATEGORY_SETTINGS: '/category-settings',
  CATEGORIES: '/categories',
  BATTLE: '/battle',
  BATTLES: '/battles',
  SINGLE_BATTLES: '/single-battles',
  SINGLE_BATTLE_COMMENTS: '/single-battle-comments',
  ELIMINATION_TOOL: '/elimination-tools',
  BATTLES_LIVE: '/battles-live',
  ROUNDS: '/rounds',
  VERDICTS: '/verdicts',
  SETS: '/sets',
  BATTLE_COMMENTS: '/battle-comments',
  BATTLE_VERDICT_RESULT: '/battle-comments/verdict-result',
  BATTLE_VIDEO_COMMENTS: '/battle-video-comments',
  BATTLE_NOTES: '/battle-notes',
  BATTLE_NOTE_COMMENTS: '/battle-note-comments',
  HIGHLIGHTS: '/battle-highlights',
  COMPETITOR_NOTES: '/competitor-notes',
  COMPETITOR_NOTE_COMMENTS: '/competitor-note-comments',
  COMPETITORS: '/competitors',
  ME: '/users/me',
  INTERFACE_UNLOCK_SEEN: '/users/me/interface-unlock-seen',
  LOGIN_USER: '/auth/local',
  LOGOUT: '/auth/logout',
  USERS: '/users',
  USERS_LABELS: '/users/labels',
  RAPORTS: '/raports',
  USERS_ROLES: '/users-permissions/roles',
  SIGNUP: '/auth/signup',
  REGISTER_USER: '/auth/local/register',
  FORGOT_PASSWORD: '/auth/forgot-password',
  RESET_PASSWORD: '/auth/reset-password',
  UPLOAD: '/upload',
  LEADERBOARD: '/leaderboard',
  LEADERBOARD_MY_STATS: '/leaderboard/my-stats',
  LEADERBOARD_JUDGE_STATS: '/leaderboard/judge-stats', // + /:uuid
  LEADERBOARD_CONFIG: '/leaderboard/config',
  SCORING_RULES: '/leaderboard/scoring-rules',
  JUDGE_COMMENTS: '/battle-comments',
  CHANGELOG: '/changelog',
  BATTLES_SETS: '/sets',
};